import api from './client';

// Scheduler API
export const schedulerAPI = {
  getStatus: () => api.get('/scheduler/status'),
  getJobDurations: () => api.get('/scheduler/job-durations'),
  getEventLoopLag: () => api.get('/scheduler/event-loop-lag'),
  getDeadLetterChains: () => api.get('/scheduler/dead-letter-chains'),
  getConfig: () => api.get('/scheduler/config'),
  updateConfig: (config) => api.put('/scheduler/config', config),
  triggerJob: (jobId) => api.post(`/scheduler/trigger/${jobId}`),
  getCircuits: () => api.get('/scheduler/circuits'),
  getCircuit: (service) => api.get(`/scheduler/circuits/${service}`),
  resetCircuit: (service) => api.post(`/scheduler/circuits/${service}/reset`),
};
